/* ============================================================
   Snuzone Facets v1 – Richtung A "Sheet Kompakt"
   ------------------------------------------------------------
   Zuständig für:
   - Bottom-Sheet (Mobile) + Dropdown-Panels (Desktop)
   - AJAX-Filterung über die Section Rendering API:
     fetch(url + &sections=mainId,filterId) → beide Sections
     werden geswappt, danach pushState.
   - State-Restore nach jedem Swap (Sheet offen, Akkordeons,
     Panel, Scrollposition), da das Filter-Markup serverseitig
     komplett neu gerendert wird.
   - Ein-/Zwei-Spalten-Toggle fürs Mobile-Raster (localStorage).

   Alle Events laufen delegiert über document und überleben
   dadurch jeden DOM-Swap. Das Script wird nie erneut ausgeführt.
   ============================================================ */

(function () {
  'use strict';

  if (window.__snzFacetsInit) return;
  window.__snzFacetsInit = true;

  var doc = document;

  /* ---------- Helpers ---------- */

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  function getSectionIds() {
    var main = qs('#CollectionAjaxResult');
    var filt = qs('[data-snz-filter-section]');
    return {
      main: main ? main.getAttribute('data-section-id') : null,
      filter: filt ? filt.getAttribute('data-section-id') : null
    };
  }

  /* ---------- UI-State (überlebt Swaps) ---------- */

  var ui = {
    sheetOpen: false,
    sheetScroll: 0,
    accStates: null,   // { param_name: true/false } – null = Server-Defaults
    openPanel: null,   // Desktop-Panel-Key
    lastTrigger: null
  };

  function captureUiState() {
    var sheet = qs('[data-snz-sheet]');
    var body = qs('[data-snz-sheet-body]');
    ui.sheetOpen = !!(sheet && sheet.classList.contains('on'));
    ui.sheetScroll = body ? body.scrollTop : 0;

    var states = {};
    qsa('[data-snz-acc]').forEach(function (acc) {
      states[acc.getAttribute('data-snz-acc')] = acc.classList.contains('open');
    });
    ui.accStates = states;

    var openPanel = qs('.snz-fd__panel:not([hidden])');
    ui.openPanel = openPanel ? openPanel.getAttribute('data-snz-dd-panel') : null;
  }

  function restoreUiState() {
    if (ui.accStates) {
      qsa('[data-snz-acc]').forEach(function (acc) {
        var key = acc.getAttribute('data-snz-acc');
        if (key in ui.accStates) {
          acc.classList.toggle('open', ui.accStates[key]);
          var head = qs('[data-snz-acc-head]', acc);
          if (head) head.setAttribute('aria-expanded', ui.accStates[key] ? 'true' : 'false');
        }
      });
    }

    if (ui.sheetOpen) {
      var sheet = qs('[data-snz-sheet]');
      if (sheet) {
        sheet.classList.add('snz-noanim', 'on');
        showOverlay(true);
        lockScroll(true);
        var body = qs('[data-snz-sheet-body]');
        if (body) body.scrollTop = ui.sheetScroll;
        // Transition nach dem Restore wieder aktivieren
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            sheet.classList.remove('snz-noanim');
          });
        });
      }
    }

    if (ui.openPanel) {
      var panel = qs('.snz-fd__panel[data-snz-dd-panel="' + ui.openPanel + '"]');
      var trigger = qs('.snz-fd__t[data-snz-dd="' + ui.openPanel + '"]');
      if (panel) panel.hidden = false;
      if (trigger) {
        trigger.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
  }

  /* ---------- Sheet / Overlay ---------- */

  function showOverlay(show) {
    var ov = qs('[data-snz-overlay]');
    if (!ov) return;
    if (show) {
      ov.hidden = false;
      requestAnimationFrame(function () { ov.classList.add('on'); });
    } else {
      ov.classList.remove('on');
      window.setTimeout(function () { ov.hidden = true; }, 260);
    }
  }

  function lockScroll(lock) {
    doc.documentElement.classList.toggle('snz-lock', lock);
  }

  function openSheet(trigger) {
    var sheet = qs('[data-snz-sheet]');
    if (!sheet) return;
    ui.lastTrigger = trigger || null;
    ui.sheetOpen = true;
    sheet.classList.add('on');
    showOverlay(true);
    lockScroll(true);
    sheet.focus({ preventScroll: true });
  }

  function closeSheet() {
    var sheet = qs('[data-snz-sheet]');
    if (!sheet) return;
    ui.sheetOpen = false;
    sheet.classList.remove('on');
    showOverlay(false);
    lockScroll(false);
    if (ui.lastTrigger && doc.contains(ui.lastTrigger)) {
      ui.lastTrigger.focus({ preventScroll: true });
    }
    ui.lastTrigger = null;
  }

  /* ---------- Desktop-Panels ---------- */

  function closeAllPanels() {
    qsa('.snz-fd__panel').forEach(function (p) { p.hidden = true; });
    qsa('.snz-fd__t').forEach(function (t) {
      t.classList.remove('open');
      t.setAttribute('aria-expanded', 'false');
    });
    ui.openPanel = null;
  }

  function togglePanel(trigger) {
    var key = trigger.getAttribute('data-snz-dd');
    var panel = qs('.snz-fd__panel[data-snz-dd-panel="' + key + '"]');
    if (!panel) return;
    var wasOpen = !panel.hidden;
    closeAllPanels();
    if (!wasOpen) {
      panel.hidden = false;
      trigger.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      ui.openPanel = key;
    }
  }

  /* ---------- AJAX: Section-API mit Dokument-Fallback ---------- */

  var currentFetch = null;

  function swapSection(id, html) {
    if (!html) {
      console.warn('[snz-facets] Keine Section-HTML für:', id);
      return false;
    }
    var wrapper = doc.getElementById('shopify-section-' + id);
    if (!wrapper) {
      console.warn('[snz-facets] Wrapper fehlt im DOM: #shopify-section-' + id);
      return false;
    }
    var tmp = doc.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.firstElementChild;
    wrapper.innerHTML = fresh ? fresh.innerHTML : html;
    return true;
  }

  // Weg 1: Section Rendering API (?sections=a,b → JSON)
  function fetchViaSectionsApi(target, ids) {
    var u = new URL(target.toString());
    u.searchParams.set('sections', ids.main + ',' + ids.filter);
    return window.fetch(u.toString(), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json[ids.main] && !json[ids.filter]) {
          console.warn('[snz-facets] Sections-Antwort ohne passende Keys. Erwartet:', ids.main, '+', ids.filter, '| erhalten:', Object.keys(json));
          throw new Error('Antwort enthält keine der angefragten Sections');
        }
        return { main: json[ids.main] || null, filter: json[ids.filter] || null, via: 'sections-api' };
      });
  }

  // Weg 2: Komplettes Dokument holen und Sections herausschneiden
  function fetchViaDocument(target, ids) {
    return window.fetch(target.toString(), { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var m = parsed.getElementById('shopify-section-' + ids.main);
        var f = parsed.getElementById('shopify-section-' + ids.filter);
        if (!m && !f) throw new Error('Sections im Dokument nicht gefunden');
        return { main: m ? m.outerHTML : null, filter: f ? f.outerHTML : null, via: 'document' };
      });
  }

  /* Nach jedem Grid-Swap: Theme- und App-Bindings reaktivieren.
     Der Swap ersetzt die Produktkarten im DOM – Quick Shop, Hover-Bilder
     und Wishlist-Buttons verlieren dabei ihre Event-Handler. Impulse
     stellt dafür theme.reinitProductGridItem bereit, Swym eine eigene API. */
  var reinitLogged = false;

  /* custom.js ist ein picoapp-Bundle: Produktkarten (data-component="ProductItem")
     werden beim Pageload gemountet, der Mobile-ATC-Handler dabei pro Button
     gebunden. Nach einem Swap sind die Karten ungemountete neue Nodes –
     app.mount() scannt das DOM und mountet sie nach (derselbe Aufruf, den
     custom.js selbst nach dem Modal-Inject macht). */
  function remountPicoapp() {
    var candidates = [
      window.app,
      window.App,
      window.__app,
      window.theme && window.theme.app
    ];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c && typeof c.mount === 'function') {
        try {
          c.mount();
          return true;
        } catch (err) {
          console.warn('[snz-facets] picoapp mount() fehlgeschlagen:', err);
          return false;
        }
      }
    }
    return false;
  }

  /* ---------- Mobile-ATC via Proxy-Click ----------
     custom.js (picoapp-Bundle) bindet den Mobile-ATC-Handler beim Pageload
     pro Button; die App-Instanz ist nicht global exponiert, ein Remount
     nach dem Swap daher unmöglich. Lösung: Vor dem ersten Swap wird ein
     original gebundener Button unsichtbar in <body> geparkt – Listener
     wandern beim Verschieben mit. Taps auf ungebundene Buttons aus dem
     Swap feuern einen synthetischen Klick auf diesen Proxy: exakt der
     originale Code-Pfad inkl. Modal-Inject und app.mount().
     __snzQuickShopClick ist der im Shop etablierte Guard, damit
     Drawer-Skripte synthetische Klicks ignorieren. */

  var atcProxy = null;

  function ensureAtcProxy() {
    if (atcProxy && doc.contains(atcProxy)) return atcProxy;
    var btn = qs('#CollectionAjaxResult [data-mobile-add-to-cart]');
    if (!btn || !btn.parentNode) return null;
    btn.parentNode.removeChild(btn);
    btn.setAttribute('data-snz-atc-proxy', '');
    btn.setAttribute('aria-hidden', 'true');
    btn.style.display = 'none';
    doc.body.appendChild(btn);
    atcProxy = btn;
    return atcProxy;
  }

  function tagUnboundAtc() {
    qsa('#CollectionAjaxResult [data-mobile-add-to-cart]').forEach(function (b) {
      b.setAttribute('data-snz-unbound', '');
    });
  }

  function openMobileAtc(handle) {
    var proxy = ensureAtcProxy();
    if (proxy) {
      var orig = proxy.getAttribute('data-handle');
      proxy.setAttribute('data-handle', handle);
      window.__snzQuickShopClick = true;
      try {
        proxy.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      } finally {
        proxy.setAttribute('data-handle', orig || '');
        window.setTimeout(function () { window.__snzQuickShopClick = false; }, 0);
      }
      return;
    }
    // Notfall ohne Proxy: Modal-Flow minimal nachbauen (ohne app.mount)
    console.warn('[snz-facets] Kein ATC-Proxy verfügbar – Fallback-Modal');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.fetch(root + 'products/' + encodeURIComponent(handle) + '?view=ajax-product')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var modal = qs('.ModalForm');
        if (!modal) return;
        modal.innerHTML = html;
        modal.classList.add('active');
      })
      .catch(function (err) {
        console.warn('[snz-facets] Fallback-Modal fehlgeschlagen:', err);
      });
  }

  function reinitThemeGrid(mainSectionId) {
    var picoappMounted = remountPicoapp();
    try {
      if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
        window.theme.reinitProductGridItem();
      }
    } catch (err) {
      console.warn('[snz-facets] Theme-Reinit fehlgeschlagen:', err);
    }
    try {
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons('#CollectionAjaxResult');
      }
    } catch (err) {
      console.warn('[snz-facets] Swym-Reinit fehlgeschlagen:', err);
    }
    if (!reinitLogged) {
      reinitLogged = true;
      console.info('[snz-facets] Reinit-Wege:', {
        picoappMount: picoappMounted,
        reinitProductGridItem: !!(window.theme && typeof window.theme.reinitProductGridItem === 'function'),
        swym: !!(window._swat && typeof window._swat.initializeActionButtons === 'function')
      });
    }
  }

  function navigate(url, opts) {
    opts = opts || {};
    var ids = getSectionIds();

    if (!ids.main || !ids.filter || !window.fetch || !window.URL || !window.DOMParser) {
      console.warn('[snz-facets] Vollnavigation – main:', ids.main, '| filter:', ids.filter);
      window.location.href = url;
      return;
    }

    captureUiState();

    var target;
    try {
      target = new URL(url, window.location.origin);
    } catch (e) {
      window.location.href = url;
      return;
    }

    doc.documentElement.classList.add('snz-facets-loading');
    var token = {};
    currentFetch = token;
    var t0 = (window.performance && performance.now) ? performance.now() : 0;

    fetchViaSectionsApi(target, ids)
      .catch(function (err) {
        console.warn('[snz-facets] Section-API fehlgeschlagen (' + err.message + '), Dokument-Fallback …');
        return fetchViaDocument(target, ids);
      })
      .then(function (result) {
        if (currentFetch !== token) return; // veraltete Antwort verwerfen
        var ms = t0 ? Math.round(performance.now() - t0) : '?';
        console.info('[snz-facets] Gefiltert via ' + result.via + ' in ' + ms + 'ms');
        ensureAtcProxy();

        /* Description konservieren: Sie ändert sich beim Filtern nicht,
           enthält aber per Shortcode initialisierte Slider (Swiper) und
           andere JS-Zustände, die ein frischer Render zerstören würde.
           Original-Knoten vor dem Swap lösen, danach die tote Kopie
           damit ersetzen – Instanzen und Listener wandern mit. */
        var preservedDesc = qs('#collection-description');
        if (preservedDesc && preservedDesc.parentNode) {
          preservedDesc.parentNode.removeChild(preservedDesc);
        }

        var okMain = swapSection(ids.main, result.main);
        var okFilter = swapSection(ids.filter, result.filter);
        if (!okMain && !okFilter) {
          throw new Error('Swap fehlgeschlagen (' + result.via + ')');
        }

        if (preservedDesc) {
          var freshDesc = qs('#collection-description');
          if (freshDesc && freshDesc.parentNode) {
            freshDesc.parentNode.replaceChild(preservedDesc, freshDesc);
          }
        }
        if (!opts.skipHistory) {
          window.history.pushState({ snzFacets: true }, '', target.pathname + target.search);
        }
        restoreUiState();
        updateStickyOffset();
        tagUnboundAtc();
        reinitThemeGrid(ids.main);
        doc.dispatchEvent(new CustomEvent('snz:facets:updated'));
      })
      .catch(function (err) {
        console.warn('[snz-facets] AJAX endgültig fehlgeschlagen, Vollnavigation:', err);
        window.location.href = url;
      })
      .then(function () {
        if (currentFetch === token) {
          doc.documentElement.classList.remove('snz-facets-loading');
        }
      });
  }

  /* ---------- Preis ---------- */

  function removeParamValue(params, key, value) {
    var kept = [];
    params.getAll(key).forEach(function (v) {
      if (v !== value) kept.push(v);
    });
    params.delete(key);
    kept.forEach(function (v) { params.append(key, v); });
  }

  /* Optimistic UI: Auswahl-Status sofort spiegeln, Server bestätigt per Swap. */
  function optimisticToggle(el) {
    if (el.classList.contains('snz-achip')) {
      el.style.opacity = '0.4';
      el.style.pointerEvents = 'none';
      return;
    }
    if (el.hasAttribute('data-snz-sort')) {
      var group = el.parentElement;
      if (group) {
        qsa('.snz-rrow', group).forEach(function (r) { r.classList.remove('sel'); });
      }
      el.classList.add('sel');
      return;
    }
    el.classList.toggle('sel');
  }

  /* URL clientseitig aus location.search bauen – Links im DOM können bei
     schnellen Folge-Klicks veraltet sein (Race), location ist es nie,
     weil wir sie vor jedem Fetch optimistisch pushen. */
  function applyParamNavigation(el) {
    var param = el.getAttribute('data-snz-param');
    var value = el.getAttribute('data-snz-value');
    var params = new URLSearchParams(window.location.search);

    if (param === 'sort_by') {
      params.set('sort_by', value);
    } else if (el.hasAttribute('data-snz-active')) {
      removeParamValue(params, param, value);
      el.removeAttribute('data-snz-active');
    } else {
      params.append(param, value);
      el.setAttribute('data-snz-active', '');
    }

    optimisticToggle(el);

    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '');
    window.history.pushState({ snzFacets: true }, '', newUrl);
    navigate(newUrl, { skipHistory: true });
  }

  /* ---------- Sticky via Fixed-Modus ----------
     position:sticky klebt nur innerhalb der Höhe des Elternelements –
     und die endet in dieser Template-Struktur direkt unter der Section.
     Deshalb: Sobald die Leiste die Header-Unterkante erreicht, schaltet
     sie auf position:fixed (Platzhalter verhindert den Layout-Sprung),
     beim Zurückscrollen rastet sie wieder in den Fluss ein.
     Immun gegen Overflow-Ancestors und Container-Höhen. */

  var mqDesktop = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  var fixedPlaceholder = null;
  var isFixed = false;
  var pinnedLogged = false;

  var HEADER_CANDIDATES = ['header.site-header', '.site-header__wrapper', '#HeaderWrapper', '#shopify-section-header'];

  function getHeaderBottom(root) {
    var isDesktop = mqDesktop ? mqDesktop.matches : true;
    var manual = parseInt(root.getAttribute(isDesktop ? 'data-snz-offset-d' : 'data-snz-offset-m'), 10) || 0;
    if (manual) return manual;

    /* Nur Elemente zählen, die wirklich fixed/sticky gerechnet sind –
       Wrapper wie #shopify-section-header bleiben oft im Fluss und
       scrollen weg, während das innere header.site-header fixiert ist. */
    var best = 0;
    var bestSel = null;
    for (var i = 0; i < HEADER_CANDIDATES.length; i++) {
      var el = qs(HEADER_CANDIDATES[i]);
      if (!el) continue;
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var b = el.getBoundingClientRect().bottom;
      if (b > best) { best = b; bestSel = HEADER_CANDIDATES[i]; }
    }
    if (bestSel && !pinnedLogged) {
      pinnedLogged = true;
      console.info('[snz-facets] Fixierter Header erkannt:', bestSel, '– Offset', Math.round(best) + 'px');
    }
    return Math.min(300, Math.max(0, Math.round(best)));
  }

  function updateStickyOffset() {
    var root = qs('[data-snz-filter-section]');
    if (!root) return;
    var wrapper = root.closest('[id^="shopify-section-"]');
    if (!wrapper) return;

    var hb = getHeaderBottom(root);

    if (!isFixed) {
      var rect = wrapper.getBoundingClientRect();
      if (rect.top <= hb) {
        fixedPlaceholder = doc.createElement('div');
        fixedPlaceholder.setAttribute('data-snz-sticky-ph', '');
        fixedPlaceholder.style.height = wrapper.offsetHeight + 'px';
        fixedPlaceholder.style.marginBottom = window.getComputedStyle(wrapper).marginBottom;
        wrapper.parentNode.insertBefore(fixedPlaceholder, wrapper);
        wrapper.classList.add('snz-fixed');
        wrapper.style.top = hb + 'px';
        isFixed = true;
      }
    } else {
      var phRect = fixedPlaceholder ? fixedPlaceholder.getBoundingClientRect() : null;
      if (!phRect || phRect.top > hb) {
        wrapper.classList.remove('snz-fixed');
        wrapper.style.top = '';
        if (fixedPlaceholder && fixedPlaceholder.parentNode) {
          fixedPlaceholder.parentNode.removeChild(fixedPlaceholder);
        }
        fixedPlaceholder = null;
        isFixed = false;
      } else {
        wrapper.style.top = hb + 'px';
      }
    }
  }

  function normalizePrice(value) {
    var v = String(value || '').replace(',', '.').replace(/[^\d.]/g, '');
    if (v === '' || isNaN(parseFloat(v))) return null;
    return parseFloat(v);
  }

  function applyPrice(wrap) {
    var gteInput = qs('[data-snz-price="gte"]', wrap);
    var lteInput = qs('[data-snz-price="lte"]', wrap);
    var gte = normalizePrice(gteInput && gteInput.value);
    var lte = normalizePrice(lteInput && lteInput.value);

    var params = new URLSearchParams(window.location.search);
    if (gte !== null) { params.set('filter.v.price.gte', gte); } else { params.delete('filter.v.price.gte'); }
    if (lte !== null) { params.set('filter.v.price.lte', lte); } else { params.delete('filter.v.price.lte'); }

    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '');
    window.history.pushState({ snzFacets: true }, '', newUrl);
    navigate(newUrl, { skipHistory: true });
  }

  /* ---------- Events (delegiert, überleben jeden Swap) ---------- */

  /* Capture-Phase: läuft garantiert VOR allen Theme-/Alt-Scripts,
     die Klicks auf Filter-Links abfangen könnten. */
  doc.addEventListener('click', function (e) {
    var el;

    // Sheet öffnen
    el = e.target.closest('[data-snz-open]');
    if (el) { e.preventDefault(); e.stopPropagation(); openSheet(el); return; }

    // Sheet schließen (X, CTA, Overlay)
    el = e.target.closest('[data-snz-close], [data-snz-overlay]');
    if (el) { e.preventDefault(); e.stopPropagation(); closeSheet(); return; }

    // Akkordeon
    el = e.target.closest('[data-snz-acc-head]');
    if (el) {
      e.stopPropagation();
      var acc = el.closest('[data-snz-acc]');
      if (acc) {
        var open = acc.classList.toggle('open');
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    // Desktop-Panel
    el = e.target.closest('[data-snz-dd]');
    if (el) { e.stopPropagation(); togglePanel(el); return; }

    // Mobile-ATC aus geswapptem Raster → Proxy-Click (originaler Handler)
    el = e.target.closest('[data-mobile-add-to-cart][data-snz-unbound]');
    if (el) {
      e.preventDefault();
      e.stopPropagation();
      openMobileAtc(el.getAttribute('data-handle'));
      return;
    }

    // Filter-/Sortier-/Chip-Links → AJAX
    el = e.target.closest('a[data-snz-nav]');
    if (el) {
      e.preventDefault();
      e.stopPropagation();
      if (el.getAttribute('data-snz-param')) {
        applyParamNavigation(el);
      } else {
        navigate(el.getAttribute('href'));
      }
      return;
    }

    // Klick außerhalb schließt Desktop-Panels
    if (!e.target.closest('[data-snz-filter-section]')) {
      if (qs('.snz-fd__panel:not([hidden])')) closeAllPanels();
    }
  }, true);

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sheet = qs('[data-snz-sheet]');
    if (sheet && sheet.classList.contains('on')) { closeSheet(); return; }
    if (qs('.snz-fd__panel:not([hidden])')) closeAllPanels();
  });

  // Preis: Enter oder Verlassen des Feldes wendet an
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-snz-price]');
    if (!input) return;
    e.preventDefault();
    applyPrice(input.closest('[data-snz-price-wrap]'));
  });

  doc.addEventListener('change', function (e) {
    var input = e.target.closest('[data-snz-price]');
    if (!input) return;
    applyPrice(input.closest('[data-snz-price-wrap]'));
  });

  // Zurück/Vor im Browser
  window.addEventListener('popstate', function () {
    navigate(window.location.href, { skipHistory: true });
  });

  /* ---------- Init ---------- */

  /* Permanenter rAF-Loop statt Scroll-Listener: funktioniert auch, wenn
     das Theme in einem inneren Container statt im window scrollt. */
  (function stickyLoop() {
    updateStickyOffset();
    window.requestAnimationFrame(stickyLoop);
  })();

  console.info('[snz-facets] v2.5 bereit');
})();